import {
  Container,
  Box,
  Stack,
  Button,
  Typography,
  styled,
  Divider,
  IconButton,
  Snackbar,
} from "@mui/material";
import logo from "../assets/images/logo.svg";
import { ReactComponent as Telegram } from "../assets/icons/telegram.svg";
import HelpAndSupportDialog from "./dialogs/HelpAndSupportDialog";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import * as React from "react";

const Image = styled("img")``;

const Footer = () => {
  const [openConsent, setOpenConsent] = useState(true);
  const [openHelp, setOpenHelp] = useState(false);
  const handleOpenHelp = () => setOpenHelp(true);
  const handleCloseHelp = () => setOpenHelp(false);
  const consentAgreed = localStorage.getItem("consent");
  // Close footer popover
  const handleCloseConsent = (e, reason) => {
    if (reason !== "clickaway") {
      localStorage.setItem("consent", 1);
      setOpenConsent(false);
    }
  };

  // Remove footer from payment success and failure pages
  const { pathname } = useLocation();
  if (
    pathname.includes("/payment-failed") ||
    pathname.includes("/payment-success") ||
    pathname.includes("terms-and-conditions") ||
    pathname.includes("privacy-policy") ||
    pathname.includes("404")
  )
    return null;

  const ConsentAction = (
    <React.Fragment>
      <Button
        onClick={handleCloseConsent}
        variant="contained"
        sx={{
          mb: 1,
          mr: 1,
          p: "3px 10px 0px 10px !important",
          borderRadius: "5px !important",
          fontSize: "14px !important",
        }}
      >
        I agree
      </Button>
    </React.Fragment>
  );

  return (
    <Container maxWidth={"xl"} disableGutters>
      <Box
        sx={{
          pb: "70px",
        }}
      >
        <Box sx={{ mx: { lg: "100px", sm: "40px", xs: "20px" } }}>
          <Box sx={{ mx: "auto", width: { sm: "300px", xs: "200px" } }}>
            {/* <Image sx={{ width: "100%" }} src={logo} /> */}
          </Box>
          <Box sx={{ mt: "100px" }}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              flexWrap={"wrap"}
            >
              <Image
                src={logo}
                sx={{ width: "100px", display: { xs: "none", sm: "block" } }}
              />
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Button
                  sx={{
                    justifyContent: "flex-end",
                  }}
                  onClick={() => handleOpenHelp()}
                >
                  Contact
                </Button>
                <Button
                  sx={{
                    color: "white",
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                  href="/terms-and-conditions"
                >
                  Terms of Use
                </Button>
                <Button
                  style={{
                    color: "white",
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                  href="/privacy-policy"
                >
                  Privacy Policy
                </Button>
              </Box>
            </Stack>
            <Divider
              sx={{
                mb: "20px",
                mt: "18px",
                borderBottomWidth: "1px",
                bgcolor: "white",
              }}
            />
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              flexWrap={"wrap"}
              alignItems={"center"}
              rowGap={{ xs: 2, sm: 0 }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  color: "white",
                  fontWeight: 500,
                  fontFamily: "secondaryFontFamily",
                }}
              >
                {`© ${new Date().getFullYear()} Wizard-Tips. All Rights Reserved`}
              </Typography>
              <Box display={"flex"}>
                <IconButton
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://t.me/+fa3h3pdG6uliZjRl"
                  sx={{ pt: 0, pl: 0 }}
                >
                  <Telegram />
                </IconButton>
              </Box>
            </Stack>
          </Box>
        </Box>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          sx={{
            width: "100%",
            bottom: "0 !important",
            margin: 0,
            position: "fixed",
            ".MuiPaper-root": {
              backgroundColor: "white",
              color: "black",
              fontFamily: "secondaryFontFamily",
              borderRadius: "0px !important",
              fontSize: "12px",
            },
            ".MuiSnackbarContent-message": {
              paddingBottom: { lg: "0px !important", xs: "5px !important" },
            },
          }}
          action={ConsentAction}
          open={consentAgreed === null && openConsent}
          onClose={handleCloseConsent}
          message="The soccer predictions and analyses provided on this website are for informational and entertainment purposes only. This service does not constitute gambling, betting advice, or financial recommendations. We do not guarantee any specific outcomes, and past performance does not indicate future results. Users are solely responsible for their decisions and any financial risks they undertake. This website is not affiliated with any gambling operators or sportsbooks. By using this service, you acknowledge that we are not liable for any losses or consequences arising from the use of our content."
        />
      </Box>

      <HelpAndSupportDialog
        open={openHelp}
        handleDialogClose={handleCloseHelp}
      />
    </Container>
  );
};

export default Footer;
